import { serviceGetClientStats } from 'admin/services/analytics'
import generateModule from 'common/utils/generateModule'


const { actions, reducers, initialState } = generateModule({
  itemName: 'clientStats',
  autoRefresh: 3,
  getModuleState: (getState) => getState().admin.analytics.onlineEngagement.clientStats,
  services: {
    get: serviceGetClientStats,
  },
})


actions.get = (attendeeType) =>
  (dispatch, getState) => {
    dispatch(actions.getStart())
    return serviceGetClientStats(
      getState().admin.events.currentEvent.id,
      attendeeType,
      (response) => dispatch(actions.getSuccess(response)),
      () => dispatch(actions.getError()),
    )
  }


reducers['CHANGE_EVENT_SUCCESS'] = (state) => ({
  ...state,
  didInvalidate: true,
  data: initialState.data,
})


export const getClientStats = actions.get
export const getClientStatsIfNeeded = actions.getIfNeeded

const clientStats = reducers.index
export default clientStats
